import type { MessageResponse } from '@/api';
import { firstLine } from '@/lib/messages';

// The keys the backend reads sender_email / sender_name from.
const EMAIL_KEYS = ['email', 'e-mail', 'mail', 'email_address', 'your_email', 'contact_email'];
const NAME_KEYS = ['name', 'full_name', 'your_name', 'first_name'];

export function parseMessageData(data?: string | null): Record<string, unknown> | null {
  if (!data) return null;
  try {
    const parsed = JSON.parse(data);
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

const str = (value: unknown) => (typeof value === 'string' ? value.trim() : '');

/** Name, else email, from the backend fields when present, else from the data. */
export function senderOf(message: MessageResponse): string | null {
  if (message.sender_name) return message.sender_name;
  if (message.sender_email) return message.sender_email;
  const data = parseMessageData(message.data);
  if (!data) return null;
  const first = NAME_KEYS.map((k) => str(data[k])).find(Boolean);
  if (first) {
    const last = str(data.last_name);
    return last && first !== last ? `${first} ${last}` : first;
  }
  return EMAIL_KEYS.map((k) => str(data[k])).find(Boolean) ?? null;
}

/** `firstLine` of the data, cut to `max` characters. */
export function firstLineOf(message: MessageResponse, max = 140): string {
  const data = parseMessageData(message.data);
  if (!data) return '';
  const line = firstLine(data).trim();
  return line.length > max ? `${line.slice(0, max - 1)}…` : line;
}
